module.exports = __webpack_public_path__ + "static/media/ja.a1e1ea51.svg";